import { Avatar } from '@utilitywarehouse/hearth-react';
import clsx from 'clsx';

import { AppointmentParticipantType } from '@generated/gql/graphql';

import './styles.scss';

interface ParticipantAvatarProps {
  userType: AppointmentParticipantType;
  name: string;
  speaking: boolean;
}

const ParticipantAvatar = ({
  userType,
  name,
  speaking,
}: ParticipantAvatarProps) => {
  const formattedUserType = userType.toLowerCase().replace('_', '-');
  return (
    <Avatar
      className={clsx(
        'remote__ParticipantAvatar',
        `remote__ParticipantAvatar--${formattedUserType}`,
        { ['remote__ParticipantAvatar--speaking']: speaking }
      )}
      name={name}
    />
  );
};

export { ParticipantAvatar };
